document.addEventListener('DOMContentLoaded', function () {
    let baseUrl = '/api/reports?page=';
    let currentPage = 1;
    let last;
    var tagId = null;
    const buttonContainerNext = document.getElementById('nextPageButton');
    const buttonContainerPrev = document.getElementById('prevPageButton');
    const allReports = document.getElementById('see-all__reports');
    allReports.addEventListener('click', function () {
        buttonContainerNext.style.display = 'flex'
        buttonContainerPrev.style.display = 'flex'
        baseUrl = '/api/reports?page=';
        removeActive()
        allReports.classList.add('active-filter')

        paginArh(1);
    });
    urlParameters()

    function urlParameters() {
        const currentUrl = window.location.href;
        const urlParts = currentUrl.split('?');
        if (urlParts.length > 1) {
            const queryParams = urlParts[1];
            const paramsArray = queryParams.split('&');
            const paramsObject = {};
            paramsArray.forEach(param => {
                const [key, value] = param.split('=');
                paramsObject[key] = value;
            });
            console.log(paramsObject);
            baseUrl = `/api/reports?page=${paramsObject.page}&tag_id=${paramsObject.tag_id}&per_page=12`;
            var page = paramsObject.page;
            allRepoptesFilters(baseUrl, paramsObject.tag_id)
        } else {
            console.log('No query parameters found in the URL.');
        }
    }

    function paginArh(page) {
        const url = baseUrl + page;

        fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then(response => response.json())
            .then(data => {
                clearReports();
                console.log(data)
                updateReports(data)
                currentPage = page;

                last = data.meta.last_page;
                if (data.meta.last_page > 1) {
                    createPaginationButtons(data.meta.last_page);
                    buttonContainerNext.style.display = 'flex'
                    buttonContainerPrev.style.display = 'flex'
                } else {
                    let container = document.getElementById('pag-container');
                    if (container) {
                        container.remove();
                    }
                }

            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    paginArh(currentPage);

    function createPaginationButtons(totalPages) {
        const buttonContainer = document.getElementById('see-more-container');

        buttonContainer.innerHTML = '';

        for (let i = 1; i <= totalPages; i++) {
            const button = document.createElement('button');
            button.textContent = i;
            if (i === currentPage) {
                button.classList.add('active-btn');
            }
            (function (pageNumber) {
                button.addEventListener('click', function () {
                    paginArh(pageNumber);
                });
            })(i);

            buttonContainer.appendChild(button);
        }
    }

    function clearReports() {
        const newsContainer = document.querySelector('.reports-wrapper');
        if (newsContainer) {
            newsContainer.innerHTML = '';
        }
    }

    function updateReports(data) {
        const newsContainer = document.querySelector('.reports-wrapper');
        if (newsContainer && data.data) {
            data.data.forEach(item => {
                const itemElement = document.createElement('div');
                itemElement.classList.add('report-wrapper__item');
                itemElement.setAttribute('data-category__filter', `${item.tag}`);
                itemElement.onclick = function () {
                    window.location.href = `/reports/${item.slug}`;
                };
                itemElement.innerHTML = `
                 <div class="img-wrapper">
                            <img
                                src="${item.image}"
                                alt="photo">
                            <a href="reports/${item.slug}"
                               class="image-text">Детальніше</a>
                        </div>
                         <div class="slider-text">

                                <div class="slider-text__category">
                                   ${item.tag}
                                </div>

                            <h4 class="slider-text__title">
                                       ${item.title}
                            </h4>
                            <div class="slider-text__desc">
                          ${item.short_description}
                            </div>
                               <template x-if="${item.earned_amount}!==0">
                            <div class="slider-remained__wrapper">
                                <div class="text">
                                   Зібрано:
                                </div>
                                <div x-text="'${item.earned_amount}' +' грн'"
                                     class="slider-remained__wrapper-value"></div>
                            </div>
                            </template>
                        </div>
            `;
                newsContainer.appendChild(itemElement);
            });
        }
    }


    const prev = document.getElementById('prevPageButton');
    prev.addEventListener('click', function () {
        PrevPage();
    });

    const next = document.getElementById('nextPageButton');
    next.addEventListener('click', function () {
        NextPage();
    });

    function PrevPage() {
        if (currentPage > 1) {
            currentPage--;
            paginArh(currentPage);
        }
    }

    function NextPage() {
        if (currentPage < last) {
            currentPage++;
            paginArh(currentPage);
        }
    }

    const categoryItemsAll = document.querySelectorAll('.reports-category__items:not(#see-all__reports)');
    categoryItemsAll.forEach(item => {
        item.addEventListener('click', function () {
            const categoryId = item.dataset.category;
            console.log(categoryId)
            var baseUrl = `/api/reports?page=${currentPage}&tag_id=${categoryId}&per_page=12`;
            tagId = categoryId;
            removeActive()
            item.classList.add('active-filter')
            allRepoptesFilters(baseUrl, categoryId);
        });
    });

    function allRepoptesFilters(url, categoryId) {
        fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then(response => response.json())
            .then(response => {
                clearReports();
                updateReports(response);
                const elementsCount = response.data.length;
                const perPage = 12;

                if (elementsCount > perPage) {
                    buttonContainerNext.style.display = 'flex'
                    buttonContainerPrev.style.display = 'flex'
                    createPaginationButtons(Math.ceil(elementsCount / perPage));
                } else {
                    const buttonContainer = document.getElementById('see-more-container');
                    buttonContainerNext.style.display = 'none'
                    buttonContainerPrev.style.display = 'none'

                    if (buttonContainer) {
                        buttonContainer.innerHTML = '';
                    }
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }


    function queryUrl() {
        const currentUrl = window.location.href;
        const urlParts = currentUrl.split('?');
        if (urlParts.length > 1) {
            const queryParams = urlParts[1];
            const paramsArray = queryParams.split('&');
            const paramsObject = {};
            paramsArray.forEach(param => {
                const [key, value] = param.split('=');
                paramsObject[key] = value;
            });
            console.log(paramsObject);
        } else {
            console.log('No query parameters found in the URL.');
        }
    }

    function removeActive() {
        const categoryItemsAll = document.querySelectorAll('.reports-category__items:not(#see-all__reports)');
        categoryItemsAll.forEach(otherItem => {
            otherItem.classList.remove('active-filter');
            allReports.classList.remove('active-filter')
        });
    }
});


